import React, { useState } from "react";
import './Toast.css'
import { Globals } from "../../global/Globals";

const Toast = (props) => {
    const [isOpen, setIsOpen] = useState(true);
    const customStyle = "";
    const closePopup = () => {
        setIsOpen(false);
        props?.onClose && props.onClose();
    };
const imgPath = () =>{
     switch (props.status) {
        case "success":
            return Globals.IMG.ACCEPTED;
        case "error":
            return Globals.IMG.ERROR;
        default:
            return Globals.IMG.INFO_BLUE;
     }
}

    //Success #2b681d
    // #004894 className={`${styles.pulseBtn} ${styles.pulseClickButton}`}
    return (
    
        <>
            {isOpen && <div className={`${props.extraClass?props.extraClass:"toast-success-container"}`}>
                <div className={`toast-bg-cover ${props.status}`} >
                    <div className={`toast-content ${customStyle}`}>

                        <div className="toast-title">
                            <h6>
                            <img className={props.status+'-icon'} src={imgPath()} alt={props.status+'icon'}/>
                                {props.title || "Proposal has been successfully submitted"}
                            </h6>
                            <img className="close-button-toast" src={Globals.IMG.CLOSE} onClick={closePopup} />
                        </div>

                        
                    </div>
                </div>
            </div>}
        </>
    );
};

export default Toast;